export default __webpack_public_path__ + "static/media/neo_legend.99fa2ce5.png";